import type { Entity } from "../world/Entity";
import { getComponent } from "../world/Entity";
import type { Interaction, InteractionContext } from "./Interaction";
import type { InventoryItem } from "../inventory/Inventory";

export class InteractionRegistry {
  private readonly interactions = new Map<string, Interaction>();

  register(interaction: Interaction): void {
    this.interactions.set(interaction.id, interaction);
  }

  get(id: string): Interaction | undefined {
    return this.interactions.get(id);
  }

  /** Interaction ids the entity's `Interactable` component declares, filtered by `canExecute` and scope. */
  availableFor(entity: Entity, context: InteractionContext): readonly Interaction[] {
    const interactable = getComponent(entity, "interactable");
    if (!interactable) return [];
    const result: Interaction[] = [];
    for (const id of interactable.interactions) {
      const interaction = this.interactions.get(id);
      if (!interaction) continue;
      if (interaction.scope === "inventory") continue;
      if (interaction.canExecute({ ...context, entity })) result.push(interaction);
    }
    return result;
  }

  /** Interactions applicable to an inventory item, filtered by `canExecute` and scope. */
  availableForInventory(item: InventoryItem, context: InteractionContext): readonly Interaction[] {
    const result: Interaction[] = [];
    for (const interaction of this.interactions.values()) {
      if (interaction.scope === "scene") continue;
      if (interaction.canExecute({ ...context, instanceId: item.instanceId, inventoryItem: item })) {
        result.push(interaction);
      }
    }
    return result;
  }
}
